/**
 * Fonte ÚNICA da configuração de download do ARGINK Bridge (§10).
 *
 * Nenhum outro módulo lê `import.meta.env.VITE_BRIDGE_*` diretamente — só este
 * arquivo. Apontar para um instalador real depois é uma troca num lugar só (as
 * variáveis de ambiente da implantação), sem tocar em componente nenhum.
 *
 * Ausência de `VITE_BRIDGE_INSTALL_URL` é um estado HONESTO, não um bug: significa
 * que esta implantação ainda não publicou instalador. `BridgePanel` trata `null`
 * dizendo isso ao signatário, em vez de oferecer um botão "Baixar" que não leva a
 * lugar nenhum — nunca inventamos uma URL de domínio que não existe.
 */
export interface BridgeDownloadConfig {
  /** Onde baixar o instalador. */
  url: string;
  /** Versão mínima que este signer-ui sabe operar — informativo; quem barra de
   * verdade uma versão velha é `detectBridge` (`incompatible`), não este módulo. */
  minVersion: string | null;
  /** Versão recomendada — a que o botão de download hoje efetivamente instala. */
  recommendedVersion: string | null;
  /** Arquitetura do instalador Windows oferecido (hoje o único SO suportado pelo
   * ARGINK Bridge). Default `'x64'` quando a implantação não declara outra. */
  winArch: string;
  /** SHA-256 do instalador, quando publicado — para conferência antes de rodar. */
  sha256: string | null;
}

function nonEmpty(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

/**
 * `null` sse não há instalador publicado para este ambiente — estado normal, não
 * erro (ver cabeçalho). Qualquer outro campo ausente (`minVersion`,
 * `recommendedVersion`, `sha256`) também é honesto: a UI mostra o que existe e
 * omite o que não foi publicado, em vez de inventar um valor.
 */
export function getBridgeDownloadConfig(): BridgeDownloadConfig | null {
  const url = nonEmpty(import.meta.env.VITE_BRIDGE_INSTALL_URL);
  if (!url) return null;
  return {
    url,
    minVersion: nonEmpty(import.meta.env.VITE_BRIDGE_MIN_VERSION),
    recommendedVersion: nonEmpty(import.meta.env.VITE_BRIDGE_RECOMMENDED_VERSION),
    winArch: nonEmpty(import.meta.env.VITE_BRIDGE_WIN_ARCH) ?? 'x64',
    sha256: nonEmpty(import.meta.env.VITE_BRIDGE_INSTALL_SHA256),
  };
}
